<pui-sub-header>
  <div class="d-flex w-100 justify-content-between align-items-center">
    <div>
      <button pui-button variant="secondary" (click)="onGoBack()"><pui-icon left icon="arrow-left" />Powrót</button>
    </div>
    <div>@if(editMode){Edytuj wydarzenie}
      @else {
      Dodaj wydarzenie
      }

    </div>
    <div class="d-flex gap-12">
      <button pui-button variant="primary" (click)="onSubmit()">
        @if(editMode){
        Zapisz
        }@else{
        Dodaj wydarzenie
        }
      </button>
    </div>
  </div>
</pui-sub-header>


<form class="page-container" [formGroup]="form">
  <pui-form-group [title]="'Dane podstawowe'" [description]="'Wypełnij wszystkie pola, aby poprawnie zapisać wpis'">

    <pui-form-row>
      <pui-form-field>
        <pui-label>Data</pui-label>
        <input puiInput placeholder="Wybierz datę" puiDatepicker [minDate]="minDate" [startAt]="minDate"
          formControlName="date" />
        <pui-icon icon="chevron-down" right />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="form.get('date')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
    <pui-form-row>
      <pui-form-field>
        <pui-label>Typ</pui-label>
        <pui-select [multiple]="false" formControlName="eventType">
          <pui-placeholder>Typ</pui-placeholder>
          @for(option of eventTypeOptions; track $index){
          <pui-option [value]="option">{{option}}</pui-option>
          }
        </pui-select>
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="form.get('eventType')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
    <div style="display: flex; gap: 1rem; flex-direction: column">
      <pui-form-row>
        <pui-toggle-switch formControlName="repeatable" />
        <pui-label
          [supportingText]="'Włącz, jeśli wydarzenie ma się automatycznie powtarzać co roku w tym samym dniu'">Powtarzalne</pui-label>
      </pui-form-row>
    </div>
    <pui-form-row>
      <pui-form-field>
        <pui-label>Powód</pui-label>
        <input puiInput type="text" placeholder="Wpisz powód" formControlName="reason" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="form.get('reason')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
    <pui-form-row>
      <pui-form-field>
        <pui-label>Komunikat PL</pui-label>
        <textarea puiInput placeholder="Wpisz komunikat" formControlName="messagePl"></textarea>
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="form.get('messagePl')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
    <pui-form-row>
      <pui-form-field>
        <pui-label>Komunikat EN</pui-label>
        <textarea puiInput placeholder="Wpisz komunikat" formControlName="messageEn"></textarea>
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="form.get('messageEn')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>

  </pui-form-group>

</form>